import { render, staticRenderFns } from "./mainTargetDetail.vue?vue&type=template&id=5762637b&scoped=true"
import script from "./mainTargetDetail.vue?vue&type=script&lang=js"
export * from "./mainTargetDetail.vue?vue&type=script&lang=js"
import style0 from "./mainTargetDetail.vue?vue&type=style&index=0&id=5762637b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762637b",
  null
  
)

export default component.exports